import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_TENANT_SETTING = createActionTypes('FETCH_TENANT_SETTING');
export const GET_TENANT_SETTING = createActionTypes('GET_TENANT_SETTING');
export const UPDATE_TENANT_SETTING = createActionTypes('UPDATE_TENANT_SETTING');
